import { useState } from "react"
import { Maximize2 } from "lucide-react"
import { PhotoLightbox } from "./PhotoLightbox"

interface MemberPhotoTileProps {
  name: string
  photoUrl: string | null
  /** Texto bajo el nombre en el visor (por ejemplo el rol). */
  caption?: string | null
}

// Retrato 3:4 con la foto completa (object-contain, sin recorte). Con foto, abre
// un visor con la imagen ampliada; sin foto, muestra las iniciales.
export function MemberPhotoTile({ name, photoUrl, caption }: MemberPhotoTileProps) {
  const [open, setOpen] = useState<number | null>(null)
  const initials = name.split(" ").map((n) => n[0]).join("").toUpperCase().slice(0, 2) || "?"

  if (!photoUrl) {
    return (
      <div className="flex aspect-[3/4] w-full items-center justify-center bg-muted" aria-hidden="true">
        <span className="text-3xl font-semibold text-muted-foreground">{initials}</span>
      </div>
    )
  }

  return (
    <>
      <button
        type="button"
        onClick={() => setOpen(0)}
        aria-label={`Ver foto completa de ${name}`}
        className="group relative flex aspect-[3/4] w-full items-center justify-center bg-muted outline-none focus-visible:ring-2 focus-visible:ring-inset focus-visible:ring-ring"
      >
        <img src={photoUrl} alt={`Foto de ${name}`} loading="lazy" decoding="async" className="h-full w-full object-contain" />
        <span className="pointer-events-none absolute bottom-2 right-2 inline-flex h-8 w-8 items-center justify-center rounded-full bg-black/70 text-white opacity-0 transition-opacity duration-(--dur-fast) group-hover:opacity-100 group-focus-visible:opacity-100 [@media(pointer:coarse)]:opacity-100">
          <Maximize2 className="h-3.5 w-3.5" aria-hidden="true" />
        </span>
      </button>
      <PhotoLightbox
        items={[{ src: photoUrl, alt: `Foto de ${name}`, title: name, subtitle: caption ?? null }]}
        index={open}
        onIndexChange={setOpen}
      />
    </>
  )
}
